import styled from 'theme';

import calendarIcon from '../../../../../../../assets/icons/calendar.svg';

export const PeriodWrapper = styled.div`
  display: flex;
`;

export const DatePickerWrapper = styled.div`
  display: flex;
  margin-right: 4rem;
  input {
    height: 3.5rem;
    width: 8rem;
    margin-right: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 0.0625rem solid;
    border-radius: 0.1875rem;
    border-color: #e4e4e4;
    border-bottom-color: #959595;
    box-shadow: none;
    font-family: ${props => props.theme.variables.typography.primaryFont};
    font-size: 0.75rem;
    background: no-repeat 8rem 1rem;
    background-image: url(${calendarIcon});
  }
`;

export const DatePickerLabel = styled.label`
  display: inline-block;
  flex: 1 0 2rem;
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 2;
  color: ${p => p.theme.variables.customColors.textColor};
  padding-bottom: 0.5rem;
  margin-top: 1rem;
  margin-right: 0.5rem;
`;
